// Curated, UK-typical adult reference ranges for markers the remote backend
// library does NOT populate (range_low/range_high are null there). These are
// applied ONLY as a fallback so every marker still gets a range + R/A/G status.
// Values are indicative "typical adult" ranges — a user's own lab report is
// always definitive. Sex-specific variants are provided where clinically relevant.
export const FALLBACK_RANGES = {
  "Globulin": { low: 20, high: 35, scaleMin: 10, scaleMax: 50 },
  "Total Protein": { low: 60, high: 80, scaleMin: 40, scaleMax: 100 },
  "MCH": { low: 27, high: 33, scaleMin: 20, scaleMax: 40 },
  "MCHC": { low: 320, high: 360, scaleMin: 280, scaleMax: 380 },
  "MCV": { low: 80, high: 100, scaleMin: 60, scaleMax: 120 },
  "Neutrophil Count": { low: 2.0, high: 7.5, scaleMin: 0, scaleMax: 12 },
  "Non-HDL Cholesterol": { low: 0, high: 4.0, scaleMin: 0, scaleMax: 8 },
  "Phosphate": { low: 0.8, high: 1.5, scaleMin: 0, scaleMax: 3 },
  "RBC Count": {
    low: 3.9, high: 5.9, scaleMin: 3, scaleMax: 7,
    sexRanges: { male: { range_low: 4.5, range_high: 5.9 }, female: { range_low: 3.9, range_high: 5.0 } },
  },
  "FAI": {
    low: 24, high: 104, scaleMin: 0, scaleMax: 150,
    sexRanges: { male: { range_low: 24, range_high: 104 }, female: { range_low: 0, range_high: 7 } },
  },
};
